<template>
  <div class="index-container home">
    <Layout></Layout>
  </div>
</template>

<script>
import Layout from '@c/layout/Layout';

export default {
  name: 'IndexPage',
  components: {
    Layout
  },
  data() {
    return {};
  },

  computed: {},
  created() {
    // 用户身份标识  admin-管理员 org-机构(服务) school-学校 parent-家长 edu-教育局
  },

  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.index-container {
  height: 100%;
}
</style>

<style></style>
